import { observer } from 'mobx-react';
import { FC } from 'react';
import { TaxConditionsSettings } from '../../containers/TaxConditionsSettings/TaxConditionsSettings';
import { orderConfigurationStore } from '../../store/orderConfigurationStore';
import { RegCertificateUpload } from '~/view/screens/SettingsScreen/screens/Orders/components/RegCertificateUplod/RegCertificateUpload';
import { VatRegNumber } from '~/view/screens/SettingsScreen/screens/Orders/components/VatRegNumber/VatRegNumber';

export const OrderConditions: FC = observer((): JSX.Element => {
  const handleVatRegNumberChange = (value: string | undefined) => {
    orderConfigurationStore.changeOrderConditions({ vatRegistrationNumber: value });
    orderConfigurationStore.validateVatRegNumber();
  };

  const handleCertificateUpload = (file: File) => {
    orderConfigurationStore.changeOrderConditions({ certificate: file, certificateFilename: file.name, certificateUrl: '' });
    orderConfigurationStore.validateCertificateFile();
  };

  const handleCertificateUnlink = (file: File) => {
    orderConfigurationStore.changeOrderConditions({ certificate: file, certificateFilename: file.name });
  };

  return (
    <div className="d-flex">
      <div className="d-flex flex-column">
        <TaxConditionsSettings />
        <RegCertificateUpload
          name={orderConfigurationStore.orderSettings.config.certificateUrl}
          link={orderConfigurationStore.orderSettings.config.certificateUrl}
          error={orderConfigurationStore.errorMessages.certificate}
          onUpload={handleCertificateUpload}
          onUnlink={handleCertificateUnlink}
        />
      </div>
      <VatRegNumber
        value={orderConfigurationStore.orderSettings.config.vatRegistrationNumber}
        error={orderConfigurationStore.errorMessages.vatRegNumber}
        onChange={handleVatRegNumberChange}
      />
    </div>
  );
});
